import {Component} from "@angular/core";
import {InventorySearchModel} from "../inventory-search.model";
import {InventoryEntityModel} from "../inventory-entity.model"
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-inventory-search-page",
    templateUrl: "./inventory-search-page.component.html",
    providers: [provideSearchModel(InventorySearchModel), provideEntityModel(InventoryEntityModel)]
})
export class InventorySearchPageComponent extends AbstractSearchPage {

    constructor(private searchModel: InventorySearchModel) {
        super();
    }

    prepareInitialFilter(): void {
        if (this.extendedSearchParams && this.extendedSearchParams.searchParams) {
            this.searchModel.filter["filterNonStockable"] = this.extendedSearchParams.searchParams["filterNonStockable"];
        }
    }
}
